import { OddDto } from '@core/mappers/offer/dtos/OddDto';
import Odd from '@core/models/offer/Odd';

export function transformOdd(dto: OddDto): Odd {
    const odd: Odd = new Odd();
    odd.id = dto.outcomeId;
    odd.value = dto.price;
    odd.marketId = dto.marketId;
    odd.marketUuid = dto.marketUuid;
    odd.marketTag = dto.marketTags;
    odd.status = dto.status || '';
    odd.description = dto.info;
    odd.marketOrder = dto.marketGroupOrder;
    odd.offerType = dto.offerStateId;
    odd.showSpecialBetStatus = dto.showSpecialBetValue === '1';
    odd.tags = dto.tags || '';
    odd.specialBetValue = dto.specialBetValue || '';
    odd.specifiers = dto.specifiers;
    odd.code = dto.code;
    odd.uuid = dto.uuid;
    if (dto.extra) {
        odd.setSuperBetFields(dto.extra);
    }
    odd.extra = dto.extra;
    odd.initialName = dto.name;
    odd.initialMarketName = dto.marketName;
    return odd;
}
